import { render, staticRenderFns } from "./ElPastas.vue?vue&type=template&id=4be95b4f&scoped=true&"
import script from "./ElPastas.vue?vue&type=script&lang=js&"
export * from "./ElPastas.vue?vue&type=script&lang=js&"
import style0 from "./ElPastas.vue?vue&type=style&index=0&id=4be95b4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be95b4f",
  null
  
)

export default component.exports